var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{attrs:{"id":"container"}}),_c('div',{staticStyle:{"z-index":"99"},attrs:{"id":"panel"}})])
}]

export { render, staticRenderFns }